import React, { FC, ReactElement, ReactNode, useMemo } from 'react';
import { StudioModalLegacyType } from './interface/StudioModal.interface';

interface IActionButtonsContainer extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const ActionButtonsContainer: FC<IActionButtonsContainer & StudioModalLegacyType> = ({
  className = '',
  style = {},
  children,
  isLegacy = true,
}): ReactElement<any> => {
  const height = useMemo(() => (isLegacy ? 84 : 56), [isLegacy]);

  return (
    <div
      className={`flex items-center bt ${
        isLegacy ? 'b--nobel bg-whisper' : 'b--tints-default-medium bg-tints-default-medium-light'
      } br2 br--bottom pa-24-right ${className}`}
      style={{
        height,
        minHeight: height,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default ActionButtonsContainer;
